import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ColorButton from '../../../common/ColorButton'
import Color from 'color'
import { StyledButton as Button } from '../../../common/Button'
import { StyledFormElement as FormElement } from '../../../common/FormElement'
import Text from 'common/components/Text'
import Select from 'common/components/Select'
import { textSizes } from 'variables'
import { withTranslation } from 'react-i18next'
import { TextBlockOptionsContainer } from './BlockOptionsContainers'
import { Menu } from '../../../common/Menu'

const displayColor = input => {
  let c
  try {
    c = new Color(input)
  } catch (e) {
    c = new Color('grey')
  }

  if (c.alpha() === 1) return c.hex()
  return `${c.hex()} (${c.alpha() * 100}%)`
}

/*
/ Text Block Options
*/

export const TextBlockOptions = withTranslation()(
  ({
    block,
    setBlockProperties,
    boardColor,
    textEditMode,
    toggleTextEdit,
    t
  }) => {
    const { size, color, align } = block.text

    return (
      <Fragment>
        <TextSizeButton
          size={size}
          onChange={size => setBlockProperties({ 'text/size': size })}
        />
        <ColorButton
          color={color}
          onChange={color => setBlockProperties({ 'text/color': color })}
        >
          {({ ref, toggle }) => (
            <Button innerRef={ref} onClick={toggle}>
              <Text bold>{displayColor(color)}</Text>
              <FormElement.Spacer />
              <FormElement.Swatch color={color} />
            </Button>
          )}
        </ColorButton>
        <TextAlignButton
          align={align}
          onChange={align => setBlockProperties({ 'text/align': align })}
        />
        {textEditMode ? (
          <Button onClick={toggleTextEdit}>
            <Text>{t('blockOptions.text.editing')}</Text>
            <FormElement.Spacer />
            <FormElement.Radio on />
          </Button>
        ) : (
          <Button onClick={toggleTextEdit}>
            <Text>{t('blockOptions.text.edit')}</Text>
            <FormElement.Spacer />
            <FormElement.Radio />
          </Button>
        )}

        <Menu.Divider />
      </Fragment>
    )
  }
)

TextBlockOptions.propTypes = {
  block: PropTypes.object.isRequired,
  setBlockProperties: PropTypes.func.isRequired,
  boardColor: PropTypes.string,
  textEditMode: PropTypes.bool.isRequired,
  toggleTextEdit: PropTypes.func.isRequired
}

export default TextBlockOptionsContainer(withTranslation()(TextBlockOptions))

const TextSizeButton = withTranslation()(({ size, onChange, t }) => (
  <Button stretch>
    <Select
      stretch
      onChangeValue={value => onChange(parseFloat(value))}
      value={size}
    >
      {textSizes.map(size => (
        <option value={size} key={size}>
          {t(`blockOptions.text.sizes.${size}`)}
        </option>
      ))}
    </Select>
  </Button>
))

TextSizeButton.propTypes = {
  size: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

const TextAlignButton = withTranslation()(({ align, onChange, t }) => (
  <Button stretch>
    <Select stretch onChangeValue={value => onChange(value)} value={align}>
      <option value="left">{t('blockOptions.text.left')}</option>
      <option value="center">{t('blockOptions.text.center')}</option>
      <option value="right">{t('blockOptions.text.right')}</option>
    </Select>
  </Button>
))

TextAlignButton.propTypes = {
  align: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
